<template>
	<v-main>
		<v-navigation-drawer fixed clipped permanent style="padding: 64px 0px 0px 0px;">
			<v-card flat>
				<v-card-text>
					
				</v-card-text>
			</v-card>
			<template v-slot:append>
				<v-card-actions class="px-4">
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="onClear">{{ $vuetify.lang.t('$vuetify.clear') }}</v-btn>
					<v-btn color="primary" @click="onOK">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
				</v-card-actions>
			</template>
		</v-navigation-drawer>

		<!-- <z-right-side-control></z-right-side-control> -->
		<v-navigation-drawer fixed clipped permanent right floating
			style="padding: 64px 0px 0px 0px;"
        >
			<!-- mini-variant
			mini-variant-width="56" -->

			<div class="text-h5">Премія</div>
			<div class="text-h6 text-right">{{ premium | toCurrency }}</div>
			<div class="text-h5">Тариф</div>
			<div class="text-h6 text-right">{{ k }}</div>

			<v-list dense nav>
				
			</v-list>
        </v-navigation-drawer>

		<v-container style="padding: 0px 256px 0px 256px;">
			<v-card elevation="0">
				<v-card-title class="text-h5">{{ title }} {{ id ? '№' + id: '' }}</v-card-title>
				<v-card-subtitle>{{ subtitle }}</v-card-subtitle>

				<v-divider></v-divider>

				<v-card-text>
					<v-expansion-panels v-model="panel" multiple>
						<v-expansion-panel>
							<v-expansion-panel-header>Дані про автомобіль</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row dense>
									<v-col cols="12" md="3">
										<v-text-field
											v-model.trim="item.vehicle.number"
											label="Державний номер"
											outlined
											dense
											clearable
											hide-details="auto"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="3">
										<v-text-field
											v-model.trim="item.vehicle.vin"
											label="VIN-код (№ кузова)"
											outlined
											dense
											clearable
											hide-details="auto"
										></v-text-field>
									</v-col>
									<!-- Vehicle Registration Certificate (VRC) -->
								</v-row>
								<v-row dense>
									<v-col cols="12" md="3">
										<v-combobox
											v-model="item.vehicle.category"
											:items="categories"
											label="Категорія"
											outlined
											dense
											item-text="name"
											item-value="id"
											hide-details="auto"
											:rules="[rules.onlyFromList]"
											@change="onCategory"
											@focus="loadCategories"
										></v-combobox>
									</v-col>
									<v-col cols="12" md="3">
										<v-combobox
											v-model="item.vehicle.brand"
											:items="brands"
											label="Марка"
											outlined
											dense
											item-text="name"
											item-value="id"
											hide-details="auto"
											:rules="[rules.onlyFromList]"
											@change="onBrand"
											@focus="loadBrands"
										></v-combobox>
									</v-col>
									<v-col cols="12" md="3">
										<v-combobox
											v-model="item.vehicle.model"
											:items="models"
											label="Модель"
											outlined
											dense
											item-text="name"
											item-value="id"
											hide-details="auto"
											:rules="[rules.onlyFromList]"
											:loading="loading.models"
											@change="onModel"
											@focus="loadModels"
										></v-combobox>
									</v-col>
									<v-col cols="12" md="3">
										<v-combobox
											v-model="item.vehicle.yearProd"
											:items="years"
											label="Рік випуску авто"
											outlined
											dense
											hide-details="auto"
											:rules="[rules.required]"
										></v-combobox>
									</v-col>
									<v-col cols="12" md="3">
										<v-combobox
											v-model="item.vehicle.bodystyle"
											:items="bodystyles"
											label="Тип кузова"
											outlined
											dense
											item-text="name"
											item-value="id"
											hide-details="auto"
											:loading="loading.bodystyles"
											@focus="loadBodystyles"
										></v-combobox>
									</v-col>
									<v-col cols="12" md="3">
										<v-combobox
											v-model="item.vehicle.driver"
											:items="drivers"
											label="Тип приводу"
											outlined
											dense
											item-text="name"
											item-value="id"
											hide-details="auto"
											:loading="loading.drivers"
											@focus="loadDrivers"
										></v-combobox>
									</v-col>
									<v-col cols="12" md="3">
										<v-text-field
											v-model="item.vehicle.engineVolume"
											label="Об'єм двигуна, л."
											outlined
											dense
											type="number"
											hide-details="auto"
											:min="minEngineVolume"
											:max="maxEngineVolume"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="3">
										<v-combobox
											v-model="item.vehicle.fuel"
											:items="fuels"
											label="Тип палива"
											outlined
											dense
											item-text="name"
											item-value="id"
											hide-details="auto"
											:loading="loading.fuels"
											@focus="loadFuels"
										></v-combobox>
									</v-col>
									<v-col cols="12" md="3">
										<v-combobox
											v-model="item.vehicle.gearbox"
											:items="gearboxes"
											label="Коробка передач"
											outlined
											dense
											item-text="name"
											item-value="id"
											hide-details="auto"
											:loading="loading.gearboxes"
											@focus="loadGearboxes"
										></v-combobox>
									</v-col>
									<v-col cols="12" md="3">
										<v-combobox
											v-model="item.vehicle.color"
											:items="colors"
											label="Колір"
											outlined
											dense
											item-text="name"
											item-value="id"
											hide-details="auto"
											:loading="loading.colors"
											@focus="loadColors"
										></v-combobox>
									</v-col>
								</v-row>
								<v-divider class="my-3"></v-divider>
								<v-subheader>Вартість транспортного засобу</v-subheader>
								<v-row>
									<v-col cols="12" md="3">
										<v-text-field
											v-model="item.vehicle.cost"
											label="Сума"
											outlined
											dense
											type="number"
											hide-details="auto"
											:min="0"
										></v-text-field>
									</v-col>
								</v-row>

							</v-expansion-panel-content>
						</v-expansion-panel>

						<v-expansion-panel>
							<v-expansion-panel-header>Інформацію про водіїв</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row>
									<v-col cols="12" md="3">
										<v-text-field
											v-model="item.driver.age"
											label="Вік"
											outlined
											dense
											type="number"
											hide-details="auto"
											:min="0"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="3">
										<v-checkbox
											v-model="item.driver.ignoreExperience"
											label="без обмежень за стажем"
											outlined
											dense
											hide-details="auto"
										></v-checkbox>
									</v-col>
									<v-col cols="12" md="3">
										<v-text-field
											v-model="item.driver.experience"
											label="Водійський стаж"
											type="number"
											:min="0"
											outlined
											dense
											hide-details="auto"
											:disabled="item.driver.ignoreExperience"
										></v-text-field>
									</v-col>
									
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>

						<v-expansion-panel>
							<v-expansion-panel-header>Опції покриття</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row dense v-for="(option, index) in options" :key="index">
									<v-col cols="12" md="3">
										<span>{{ option.name }}</span>
									</v-col>
									<v-col cols="12" md="5">
										<v-radio-group v-model="item.option[option.code].value" class="mt-0" @change="onOption(option, $event)">
											<v-radio v-for="(value, v) in option.values" :key="v" :value="value.id" :label="value.name"></v-radio>
										</v-radio-group>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field
											v-model="item.option[option.code].k"
											label="Коефіцієнт до тарифу"
											outlined
											dense
											type="number"
											hide-details="auto"
											:min="option.min"
											:max="option.max"
										></v-text-field>
									</v-col>
								</v-row>

								
			<!-- hint="Відшкодування 100% вартості нової запчастини"
            									persistent-hint -->
											<!-- hint="Вирахування з вартості нової запчастини відсотка зносу (В залежності від віку авто)"
												persistent-hint -->

								<!-- <v-row dense>
									<v-col cols="12" md="3">
										<span>Знос транспортного засобу</span>
									</v-col>
									<v-col cols="12" md="5">
										<v-radio-group v-model="item.option.depreciation.value" class="mt-0">
											<v-radio :value="1" label="Не враховується"></v-radio>
											<v-radio :value="2" label="Враховується"></v-radio>
										</v-radio-group>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field
											v-model="item.option.depreciation.k"
											label="Коефіцієнт до тарифу"
											outlined
											dense
											type="number"
											hide-details="auto"
											:min="0"
											:max="0"
										></v-text-field>
									</v-col>
								</v-row> -->

								<!-- Нічне зберігання
									Захищене (гараж, паркінг, охорона)	0,85 – 0,95	Знижка 5% – 15%
									Без обмежень (вулиця, двір уночі)	1,10 – 1,25	Надбавка 10% – 25% -->
								<!-- <v-row dense>
									<v-col cols="12" md="3">
										<span>Нічне зберігання</span>
									</v-col>
									<v-col cols="12" md="5">
										<v-radio-group v-model="item.option.overnightStorage.value" class="mt-0">
											<v-radio :value="1" label="Захищене (гараж, паркінг, охорона)"></v-radio>
											<v-radio :value="2" label="Без обмежень (вулиця, двір уночі)"></v-radio>
										</v-radio-group>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field
											v-model="item.option.overnightStorage.k"
											label="Коефіцієнт до тарифу"
											outlined
											dense
											type="number"
											hide-details="auto"
											:min="0"
										></v-text-field>
									</v-col>
								</v-row> -->

								<!-- Сигналізація (alarm)
									Супутникова (з диспетчером)				0,80 – 0,90	Знижка 10% – 20%
									Звичайна двостороння					0,95 – 1,00	Базовий тариф (0% – 5%)
									Без сигналізації взагалі				1,10 – 1,25	Надбавка 10% – 25% -->
								<!-- <v-row dense>
									<v-col cols="12" md="3">
										<span>Сигналізація</span>
									</v-col>
									<v-col cols="12" md="5">
										<v-radio-group v-model="item.option.alarm.value" class="mt-0">
											<v-radio :value="1" label="Супутникова (з диспетчером)"></v-radio>
											<v-radio :value="2" label="Звичайна двостороння"></v-radio>
											<v-radio :value="3" label="Без сигналізації взагалі"></v-radio>
										</v-radio-group>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field
											v-model="item.option.alarm.k"
											label="Коефіцієнт до тарифу"
											type="number"
											outlined dense hide-details="auto"
											:min="0"
										></v-text-field>
									</v-col>
								</v-row> -->

								<!-- Тип СТО (sto)
									Офіційний дилер (гарантійне СТО)		1,15 – 1,35	Надбавка 15% – 35%
									За вибором страхової компанії			1	Базовий тариф (0%)
									Калькуляція (виплата грошима на руки)	0,80 – 0,90	Знижка 10% – 20% -->
								<!-- <v-row dense>
									<v-col cols="12" md="3">
										<span>Тип СТО</span>
									</v-col>
									<v-col cols="12" md="5">
										<v-radio-group v-model="item.option.sto.value" class="mt-0">
											<v-radio :value="1" label="Офіційний дилер (гарантійне СТО)"></v-radio>
											<v-radio :value="2" label="За вибором страхової компанії"></v-radio>
											<v-radio :value="3" label="Калькуляція (виплата грошима на руки)"></v-radio>
										</v-radio-group>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field
											v-model="item.option.sto.k"
											label="Коефіцієнт до тарифу"
											type="number"
											outlined dense hide-details="auto"
											:min="0"
										></v-text-field>
									</v-col>
								</v-row> -->

								<!-- Вік автомобіля  (vehicleAge)
									Новий (до 1 року)						0,90 – 1,00	Знижка до 10% або базовий тариф
									Від 1 до 3 років						1	Базовий тариф (0%)
									Старше 5–7 років						1,05 – 1,20	Надбавка 5% – 20% -->
								<!-- <v-row dense>
									<v-col cols="12" md="3">
										<span>Вік автомобіля</span>
									</v-col>
									<v-col cols="12" md="5">
										<v-radio-group v-model="item.option.vehicleAge.value" class="mt-0">
											<v-radio :value="1" label="Новий (до 1 року)"></v-radio>
											<v-radio :value="2" label="Від 1 до 3 років"></v-radio>
											<v-radio :value="3" label="Старше 5–7 років"></v-radio>
										</v-radio-group>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field
											v-model="item.option.vehicleAge.k"
											label="Коефіцієнт до тарифу"
											type="number"
											outlined dense hide-details="auto"
											:min="0"
										></v-text-field>
									</v-col>
								</v-row> -->

								<!-- Франшиза (franchise)
									Пошкодження 0% (без франшизи)			1,20 – 1,40	Надбавка 20% – 40%
									Пошкодження 0,5% (стандарт)				1	Базовий тариф (0%)
									Пошкодження 1% – 2% (велика франшиза)	0,75 – 0,85	Знижка 15% – 25% -->
								<!-- <v-row dense>
									<v-col cols="12" md="3">
										<span>Франшиза</span>
									</v-col>
									<v-col cols="12" md="5">
										<v-radio-group v-model="item.option.franchise.value" class="mt-0">
											<v-radio :value="1" label="Пошкодження 0% (без франшизи)"></v-radio>
											<v-radio :value="2" label="Пошкодження 0,5% (стандарт)"></v-radio>
											<v-radio :value="3" label="Пошкодження 1% – 2% (велика франшиза)"></v-radio>
										</v-radio-group>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field
											v-model="item.option.franchise.k"
											label="Коефіцієнт до тарифу"
											type="number"
											outlined dense hide-details="auto"
											:min="0"
										></v-text-field>
									</v-col>
								</v-row> -->

								<!-- Водійський стаж (drivingExperience)
									Досвідчений водій (стаж понад 5 років)	0,90 – 1,00	Знижка до 10% або базовий тариф
									Молодий водій (стаж до 2 років)			1,20 – 1,50	Надбавка 20% – 50% -->
								<!-- <v-row dense>
									<v-col cols="12" md="3">
										<span>Водійський стаж</span>
									</v-col>
									<v-col cols="12" md="5">
										<v-radio-group v-model="item.option.drivingExperience.value" class="mt-0">
											<v-radio :value="1" label="Досвідчений водій (стаж понад 5 років)"></v-radio>
											<v-radio :value="2" label="Молодий водій (стаж до 2 років)"></v-radio>
										</v-radio-group>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field
											v-model="item.option.drivingExperience.k"
											label="Коефіцієнт до тарифу"
											type="number"
											outlined dense hide-details="auto"
											:min="0"
										></v-text-field>
									</v-col>
								</v-row> -->

								<!-- Кількість водіїв (driverCount)
									Обмежена кількість (1–2 особи)			1	Базовий тариф (0%)
									Будь-який водій на законних підставах	1,10 – 1,20	Надбавка 10% – 20% -->
								<!-- <v-row dense>
									<v-col cols="12" md="3">
										<span>Кількість водіїв</span>
									</v-col>
									<v-col cols="12" md="5">
										<v-radio-group v-model="item.option.driverCount.value" class="mt-0">
											<v-radio :value="1" label="Обмежена кількість (1–2 особи)"></v-radio>
											<v-radio :value="2" label="Будь-який водій на законних підставах"></v-radio>
										</v-radio-group>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field
											v-model="item.option.driverCount.k"
											label="Коефіцієнт до тарифу"
											type="number"
											outlined dense hide-details="auto"
											:min="0"
										></v-text-field>
									</v-col>
								</v-row> -->

								<!-- Місто реєстрації (cityRegistration)
									Мегаполіси (Київ, Одеса, Львів тощо)	1,10 – 1,25	Надбавка 10% – 25%
									Невеликі міста та райцентри				0,90 – 1,00	Знижка до 10% або базовий тариф -->
								<!-- <v-row dense>
									<v-col cols="12" md="3">
										<span>Місто реєстрації</span>
									</v-col>
									<v-col cols="12" md="5">
										<v-radio-group v-model="item.option.cityRegistration.value" class="mt-0">
											<v-radio :value="1" label="Мегаполіси (Київ, Одеса, Львів тощо)"></v-radio>
											<v-radio :value="2" label="Невеликі міста та райцентри"></v-radio>
										</v-radio-group>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field
											v-model="item.option.cityRegistration.k"
											label="Коефіцієнт до тарифу"
											type="number"
											outlined dense hide-details="auto"
											:min="0"
										></v-text-field>
									</v-col>
								</v-row> -->

								<!-- Воєнні ризики (militaryRisk)
									Без покриття воєнних ризиків			1	Базовий тариф (0%)
									З покриттям уламків ракет / БПЛА		1,15 – 1,50	Надбавка 15% – 50% -->
								<!-- <v-row dense>
									<v-col cols="12" md="3">
										<span>Воєнні ризики</span>
									</v-col>
									<v-col cols="12" md="5">
										<v-radio-group v-model="item.option.militaryRisk.value" class="mt-0">
											<v-radio :value="1" label="Без покриття воєнних ризиків"></v-radio>
											<v-radio :value="2" label="З покриттям уламків ракет / БПЛА"></v-radio>
										</v-radio-group>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field
											v-model="item.option.militaryRisk.k"
											label="Коефіцієнт до тарифу"
											type="number"
											outlined dense hide-details="auto"
											:min="0"
										></v-text-field>
									</v-col>
								</v-row> -->

								<!-- Призначення авто (vehiclePurpose)
									Особисте використання					1	Базовий тариф (0%)
									Таксі, прокат, оренда, доставка			1,50 – 2,50	Надбавка 50% – 150% -->
								<!-- <v-row dense>
									<v-col cols="12" md="3">
										<span>Призначення авто</span>
									</v-col>
									<v-col cols="12" md="5">
										<v-radio-group v-model="item.option.vehiclePurpose.value" class="mt-0">
											<v-radio :value="1" label="Особисте використання"></v-radio>
											<v-radio :value="2" label="Таксі, прокат, оренда, доставка"></v-radio>
										</v-radio-group>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field
											v-model="item.option.vehiclePurpose.k"
											label="Коефіцієнт до тарифу"
											type="number"
											outlined dense hide-details="auto"
											:min="0"
										></v-text-field>
									</v-col>
								</v-row> -->

								<!-- Порядок оплати (procedurePayment)
									Одноразовий платіж (100%)				1	Базовий тариф (0%)
									Розбивка на 4 платежі (щоквартально)	1,03 – 1,07	Надбавка 3% – 7% -->
								<!-- <v-row dense>
									<v-col cols="12" md="3">
										<span>Призначення авто</span>
									</v-col>
									<v-col cols="12" md="5">
										<v-radio-group v-model="item.option.procedurePayment.value" class="mt-0">
											<v-radio :value="1" label="Одноразовий платіж (100%)"></v-radio>
											<v-radio :value="2" label="Розбивка на 4 платежі (щоквартально)"></v-radio>
										</v-radio-group>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field
											v-model="item.option.procedurePayment.k"
											label="Коефіцієнт до тарифу"
											type="number"
											outlined dense hide-details="auto"
											:min="0"
										></v-text-field>
									</v-col>
								</v-row> -->
							</v-expansion-panel-content>
						</v-expansion-panel>

					</v-expansion-panels>
				</v-card-text>
			</v-card>
		</v-container>
		<!-- <v-overlay :value="loading">
			<v-progress-circular indeterminate size="64" ></v-progress-circular>
		</v-overlay> -->
		<v-snackbar v-model="snackbar.visible" :color="snackbar.color">
			{{ snackbar.text }}
			<template v-slot:action="{ attrs }">
			<v-btn icon v-bind="attrs" @click="snackbar.visible = false" >
				<v-icon>mdi-close</v-icon>
			</v-btn>
			</template>
		</v-snackbar>

		<z-pdf ref="pdf" :item="item"></z-pdf>
	</v-main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import zPdf from '@/views/pdf/VehicleAveragePriceAI'
import downloadExcel from "vue-json-excel";

export default {
	name: 'InsuranceCalculatorKasko',
	components: {
		zPdf,
	},
	data: () => ({
		title: 'КАСКО калькулятор',
		subtitle: 'Розрахунок вартісті добровільного страхування автомобіля',
		icon: 'mdi-calculator',
		minYear: 1900,
		maxYear: (new Date()).getFullYear(),
		minMileage: 1,
		maxMileage: 1000,
		minEngineVolume: 0,
		maxEngineVolume: 10,

		//loading: false,
		panel: [0,1,2,3,4,5,6,7,8,9],

		loading: {
			categories: false,
			brands: false,
			models: false,
			generations: false,
			modifications: false,
			yearProd: false,
			drivers: false,
			options: false,
			bodystyles: false,
			fuels: false,
			gearboxes: false,
			colors: false,
			countries: false,
			states: false,
			cityies: false,
		},

		categories: [],
		brands: [],
		models: [],
		generations: [],
		modifications: [],
		yearProd: [],
		drivers: [],
		options: [],
		bodystyles: [],
		fuels: [],
		gearboxes: [],
		colors: [],
		countries: [],
		states: [],
		cityies: [],

		excel: {
			name: '',
			type: 'xlsx',
			disabled: true,
			data: []
		},

		snackbar: {
			visible: false,
			text: null,
			color: null
		},

		rules: {
			required: (value) => !!value || "Обов'язкове для заповнення",
			//onlyFromList: (v) => (!!v && v?.id > 0 ) || "Необхідно обрати значення зі списку",
			onlyFromList: (v) => !v || v?.id > 0 || "Необхідно обрати значення зі списку",
		},

		options: [
			{ code: 'overnightStorage', name: 'Нічне зберігання', enable: true, values: [
					{ id: 1, name: 'Захищене (гараж, паркінг, охорона)', min:  0.85, max: 0.95 },
					{ id: 2, name: 'Без обмежень (вулиця, двір уночі)', min:  1.10, max: 1.25 },
				]
			},
			{ code: 'alarm', name: 'Сигналізація', enable: true, values: [
					{ id: 1, name: 'Супутникова (з диспетчером)', min: 0.80, max: 0.90 },
					{ id: 2, name: 'Звичайна двостороння', min: 0.95, max: 1.00 },
					{ id: 3, name: 'Без сигналізації взагалі', min: 1.10, max: 1.25 },
				]
			},
			{ code: 'sto', name: 'Тип СТО', enable: true, values: [
					{ id: 1, name: 'Офіційний дилер (гарантійне СТО)', min: 1.15, max: 1.35 },
					{ id: 2, name: 'За вибором страхової компанії', min: 1, max: 1 },
					{ id: 3, name: 'Калькуляція (виплата грошима на руки)', min: 0.80, max: 0.90 },
				]
			},
			{ code: 'vehicleAge', name: 'Вік автомобіля', enable: true, values: [
					{ id: 1, name: 'Новий (до 1 року)', min: 0.90, max: 1.00 },
					{ id: 2, name: 'Від 1 до 3 років', min: 1, max: 1 },
					{ id: 3, name: 'Старше 5–7 років', min: 1.05, max: 1.20 },
				]
			},
			{ code: 'franchise', name: 'Франшиза', enable: true, values: [
					{ id: 1, name: 'Пошкодження 0% (без франшизи)', min: 1.20, max: 1.40 },
					{ id: 2, name: 'Пошкодження 0,5% (стандарт)', min: 1, max: 1 },
					{ id: 3, name: 'Пошкодження 1% – 2% (велика франшиза)', min: 0.75, max: 0.85 },
				]
			},
           	{ code: 'drivingExperience', name: 'Водійський стаж', enable: true, values: [
					{ id: 1, name: 'Досвідчений водій (стаж понад 5 років)', min: 0.90, max: 1.00 },
					{ id: 2, name: 'Молодий водій (стаж до 2 років)', min: 1.20, max: 1.50 },
				]
			},
            { code: 'driverCount', name: 'Кількість водіїв', enable: true, values: [
					{ id: 1, name: 'Обмежена кількість (1–2 особи)', min: 1, max: 1 },
					{ id: 2, name: 'Будь-який водій на законних підставах', min: 1.10, max: 1.20 },
				]
			},
            { code: 'cityRegistration', name: 'Місто реєстрації', enable: true, values: [
					{ id: 1, name: 'Мегаполіси (Київ, Одеса, Львів тощо)', min: 1.10, max: 1.25 },
					{ id: 2, name: 'Невеликі міста та райцентри', min: 0.90, max: 1.00 },
				]
			},
            { code: 'militaryRisk', name: 'Воєнні ризики', enable: true, values: [
					{ id: 1, name: 'Без покриття воєнних ризиків', min: 1, max: 1 },
					{ id: 2, name: 'З покриттям уламків ракет / БПЛА', min: 1.15, max: 1.50 },
				]
			},
            { code: 'vehiclePurpose', name: 'Призначення авто', enable: true, values: [
					{ id: 1, name: 'Особисте використання', min: 1, max: 1 },
					{ id: 2, name: 'Таксі, прокат, оренда, доставка', min: 1.50, max: 2.50 },
				]
			},
            { code: 'procedurePayment', name: 'Порядок оплати', enable: true, values: [
					{ id: 1, name: 'Одноразовий платіж (100%)', min: 1, max: 1 },
					{ id: 2, name: 'Розбивка на 4 платежі (щоквартально)', min: 1.03, max: 1.07 },
				]
			},
		],
	}),

	props: {
		outlined:   	{ type: Boolean, default: true },
	},

	computed: {
		...mapGetters('InsuranceCalculatorKasko', [ 'item' ]),

		years() {
			const arrayRange = (start, stop, step) =>
			Array.from(
				{ length: (stop - start) / step + 1 },
				(value, index) => start + index * step
			);
			return arrayRange(this.minYear, this.maxYear, 1).reverse();
		},

		k() {
			const result = Object.values(this.item.option).reduce((accumulator, currentValue) => accumulator * currentValue.k, 1);

			return Number(result.toFixed(4));
		},

		premium() {

			const k = this.k

			//console.log(this.$options.name, 'premium','k', k)

			return (this.item.vehicle?.cost ? this.item.vehicle?.cost : 0) * k
				
		},

		id() {
			return this.item.hasOwnProperty('id') ? this.item.id: null;
		},

		/* estimates() {
			return this.item.hasOwnProperty('estimates') ? this.item.estimates: [];
		}, */
	},

	methods: {
		//...mapActions('InsuranceCalculatorKasko', [ 'setItem' ]),

		loadCategories(e) {
			if(this.categories.length == 0) {
				var that = this
				//loading
				axios.get('/vehicle/category').then(response => {
					that.categories = response.data.filter((element) => ['CAR','TRUCK'].includes(element.code))
				}, error => {
					console.log('error', error)
				})//.finally(() => (this.isLoading = false));
			}
		},

		onCategory (item) {
			this.clearBrand()
			this.clearBodystyle()
			this.clearDriver()
			this.clearGearbox()
			this.clearOption()
		},

		loadBrands() {
			if(this.item?.vehicle?.category?.id && this.brands.length == 0) {
				var that = this
				axios.get(`/vehicle/category/${this.item.vehicle.category.id}/brand`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.brands = response.data
				}, error => {
					console.log('error', error)
				});
			}
		},

		onBrand (item) {
			this.clearModel()
		},

		clearBrand () {
			this.$set(this.item.vehicle, 'brand', null)
			this.brands = []

			this.clearModel()
		},

		loadModels() {
			if(this.item?.vehicle?.category?.id && this.item?.vehicle?.brand?.id && this.models.length == 0) {
				var that = this
				axios.get(`/vehicle/category/${this.item.vehicle.category.id}/brand/${this.item.vehicle.brand.id}/models`).then(response => {
					//console.log(that.$options.name, 'GetdModels','response.data', response.data)
					that.models = response.data
				}, error => {
					console.log('error', error)
				});
			}
		},

		onModel (item) {
			this.clearGeneration()
		},

		clearModel () {
			this.$set(this.item.vehicle, 'model', null)
			this.models = []
			this.clearGeneration()
		},

		loadGenerations() {
			if(this.item?.vehicle?.model?.id && this.generations.length == 0) {
				var that = this
				axios.get(`/vehicle/model/${this.item.vehicle.model.id}/generation`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.generations = response.data
				}, error => {
					console.log('error', error)
				});
			}
		},

		onGeneration (item) {
			this.clearYearProd()
			this.clearModification()
		},

		clearGeneration () {
			this.$set(this.item.vehicle, 'generation', null)
			this.generations = []			
			this.clearModification()
		},

		// Завантаження років виробництва
		loadYearProds() {
			//console.log(this.$options.name, 'loadYearProds','generation', this.item.generation)

			this.minYear = this.item?.vehicle?.generation?.yearFrom ? this.item.vehicle.generation.yearFrom : 1900
			this.maxYear = this.item?.vehicle?.generation?.yearTo ? this.item.vehicle.generation.yearTo : (new Date()).getFullYear()
		},

		clearYearProd() {
			this.$set(this.item.vehicle, 'yearProd', null)
			//this.minYear = 1900
			//this.maxYear = (new Date()).getFullYear()
		},

		// Завантаження модифікацій
		loadModifications() {
			if(this.item?.vehicle?.generation?.id && this.modifications.length == 0) {
				var that = this
				axios.get(`/vehicle/generation/${this.item.vehicle.generation.id}/modification`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.modifications = response.data
				}, error => {
					console.log('error', error)
				});
			}
		},

		clearModification () {
			this.$set(this.item.vehicle, 'modification', null)
			this.modifications = []
		},

		// Завантаження типів кузова
		loadBodystyles() {
			if(this.item?.vehicle?.category?.id && this.bodystyles.length == 0) {
				var that = this
				axios.get(`/vehicle/category/${this.item.vehicle.category.id}/bodystyle`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.bodystyles = response.data
				}, error => {
					console.log('error', error)
				});
			}
		},

		clearBodystyle () {
			this.$set(this.item.vehicle, 'bodystyle', null)
			this.bodystyles = []
		},

		// Завантаження типів приводу
		loadDrivers() {
			if(this.item?.vehicle?.category?.id && this.drivers.length == 0) {
				var that = this
				axios.get(`/vehicle/category/${this.item.vehicle.category.id}/driver`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.drivers = response.data
				}, error => {
					console.log('error', error)
				});
			}
		},

		clearDriver () {
			this.$set(this.item.vehicle, 'driver', null)
			this.drivers = []
		},

		// Завантаження типів коробок передач
		loadGearboxes() {
			if(this.item?.vehicle?.category?.id && this.gearboxes.length == 0) {
				var that = this
				axios.get(`/vehicle/category/${this.item.vehicle.category.id}/gearbox`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.gearboxes = response.data
				}, error => {
					console.log('error', error)
				});
			}
		},

		clearGearbox () {
			this.$set(this.item.vehicle, 'gearbox', null)
			this.gearboxes = []
		},

		// Завантаження опцій
		loadOptions() {
			if(this.item?.vehicle?.category?.id && this.options.length == 0) {
				var that = this
				axios.get(`/vehicle/category/${this.item.vehicle.category.id}/option`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.options = response.data
				}, error => {
					console.log('error', error)
				});
			}
		},

		clearOption () {
			this.$set(this.item.vehicle, 'option', null)
			this.options = []
		},

		// Завантаження типів палива
		loadFuels() {
			if(this.fuels.length == 0) {
				var that = this
				axios.get('/vehicle/fuel').then(response => {
					//console.log(that.$options.name, 'created','response.data', response.data)
					that.fuels =response.data
				}, error => {
					console.log('error', error)
				});
			}
		},

		// Завантаження кольорів
		loadColors() {
			if(this.colors.length == 0) {
				var that = this
				axios.get('/vehicle/color').then(response => {
					//console.log(that.$options.name, 'created','response.data', response.data)
					that.colors =response.data
				}, error => {
					console.log('error', error)
				});
			}
		},

		// Завантаження країн виробників
		loadCountries() {
			if(this.countries.length == 0) {
				var that = this
				axios.get('/vehicle/country').then(response => {
					//console.log(that.$options.name, 'created','response.data', response.data)
					that.countries = response.data
				}, error => {
					console.log('error', error)
				});
			}
		},

		// Завантаження областей
		loadStates() {
			if(this.states.length == 0) {
				var that = this
				axios.get('/state').then(response => {
					//console.log(that.$options.name, 'created','response.data', response.data)
					that.states = response.data
				}, error => {
					console.log('error', error)
				});
			}
		},

		onState (item) {
			this.clearCity()
		},

		// Завантаження міст
		loadCities() {
			if(this.item?.vehicle?.state?.id && this.states.length == 0) {
				var that = this
				axios.get(`/state/${this.item.vehicle.state.id}/city`).then(response => {
					//console.log(that.$options.name, 'created','response.data', response.data)
					that.cities = response.data
				}, error => {
					console.log('error', error)
				});
			}
		},

		clearCity () {
			this.$set(this.item.vehicle, 'city', null)
			this.cities = []
		},

		onClear() {
			//this.$refs.parameters.reset()
			//this.clear()
		},

		onOption(option, id) {
			//console.log(this.$options.name, 'onOption', 'key', option.code, 'id', id)
			const value = option.values.find((item) => item.id === id)
			if(value) {
				this.$set(this.item.option[option.code], 'k', value.min)
			}
		},

		/* validate() {
			//return true
			return this.params.number 
				|| this.params.vin
				|| this.params.brand
				|| this.params.model
		}, */

		onOK() {
			/* if(this.$refs.parameters.validate()) {
			//if(this.validate()) {
				this.loading = true
				var that = this
				axios.post('/vehicle/estimate/averageprice/ai', this.params).then(response => {
					//console.log(that.$options.name, 'onOK','response.data', response.data)
					that.setItem(response.data)
				}, error => {
					console.log('error', error)

					that.snackbar.visible 	= true;
					that.snackbar.text 		= error.response.data.message;
					that.snackbar.color 	= null;
				}).finally(() => {
					this.loading = false
				});
			} */
		},

		onPDF () {
			this.$refs.pdf.generate()
		},
	},
}
</script>